import React, { ReactNode } from 'react';
import { classNames } from '../../utils/style';
import { Accordion } from '../../components/Accordion';
import { textBodySmall } from '../../styles/typography';
import { FaqQuestion } from './FaqQuestion';
import { fontBodyMedium } from '../../styles/typographyNew';

export interface QuestionAnswerProps {
  question: string;
  answer: ReactNode | string;
  onClick?: any;
}

export interface FaqElementProps {
  item: QuestionAnswerProps;
  onClick?: any;
  fromDato?: boolean;
  className?: string;
  btnProps?: any;
  index?: any;
}

export const FaqElement = ({
  item,
  onClick,
  className,
  index,
  btnProps,
}: FaqElementProps) => {
  return (
    <Accordion
      className={classNames(
        'FaqElement',
        className,
        'border-b last:border-0 border-[#DFE6ED]',
      )}
      question={item.question}
      answer={item.answer}
      onClick={onClick}
      index={index}
    >
      <Accordion.Button
        className={classNames(
          'relative flex items-start',
          'transition duration-200 md:items-center',
          'py-[30px] pr-[10px]',
          'text-[#042040]',
        )}
        {...btnProps}
      >
        <FaqQuestion>
          {item.question && (
            <h3 className={classNames(fontBodyMedium, 'flex-1 text-left')}>
              {item.question}
            </h3>
          )}
        </FaqQuestion>
      </Accordion.Button>
      <Accordion.Content
        animOnClose
        className={classNames('-top-16 pr-24 text-neutral-101', textBodySmall)}
      />
    </Accordion>
  );
};
